import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { reduxForm, formValueSelector } from 'redux-form';
import { FormattedMessage } from 'react-intl';
import messages from '../../../../text/messages';
import bg from './../../../../assets/images/intro.jpg';

class AcceptWitnessInvite extends React.Component {
    render() {
        const { handleSubmit, submitting, initialValues } = this.props;
        const { inviter_name, invitee_name, email } = initialValues;

        return (
            <form onSubmit={handleSubmit}>
                <div className="row">
                    <div className="col-xs-12 group">
                        <div className="box-image" style={{ backgroundImage: `url(${bg})` }} />
                        <div className="accept-witness-invite-title">
                            <FormattedMessage id="acceptWitnessInvite.title" defaultMessage="Welcome {name}!" values={{ name: invitee_name }} tagName="h4" />
                        </div>
                        <FormattedMessage
                            id="acceptWitnessInvite.intro1"
                            defaultMessage="Thanks for helping out. The purpose of this process is to examine and confirm documents that {name} has submitted for employment eligibility verification.  This shouldn’t take more than a minute or two."
                            values={{ name: inviter_name }}
                            tagName={'p'}
                        />
                        <FormattedMessage
                            id="acceptWitnessInvite.intro2"
                            defaultMessage="Note the documents must be confirmed in person.  Please make sure {name} has the physical documents ready for you to review."
                            values={{ name: inviter_name }}
                            tagName={'p'}
                        />
                    </div>
                    <div className="col-xs-12">
                        <div className="">
                            <strong>{invitee_name}</strong>
                        </div>
                        <div className="">
                            <strong>{email}</strong>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-xs-12 col-sm-6 col-sm-offset-3">
                        <button id="accept-invite-password-btn" type="submit" className="btn btn-success btn-block" disabled={submitting}>
                            <FormattedMessage {...messages.continue} />
                        </button>
                    </div>
                </div>
            </form>
        );
    }
}

AcceptWitnessInvite.defaultProps = {
    handleSubmit: undefined,
    submitting: false
};

AcceptWitnessInvite.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    submitting: PropTypes.bool
};

AcceptWitnessInvite = reduxForm({ form: 'accept-witness-invite', destroyOnUnmount: true })(AcceptWitnessInvite);
AcceptWitnessInvite = connect(state => {
    const selector = formValueSelector('accept-witness-invite');
    return {
        iAgreeToTerms: selector(state, 'iAgreeToTerms') && selector(state, 'iAgreeToTerms') === true
    };
})(AcceptWitnessInvite);

export default AcceptWitnessInvite;



// WEBPACK FOOTER //
// ./src/pages/account/forms/acceptWitnessInvite/index.jsx